import { toast } from 'react-toastify';
import UserAvatar from '../components/UserAvatar';
import { formatChatTime } from './chatTimeFormat';
import { playNotifySound } from './';

export const showToast = (message) => {
  toast.success(message, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    theme: 'dark',
    style: {
      backgroundColor: '#001529',
    },
  });
};

export const warningToast = (message) => {
  toast.warning(message, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    theme: 'dark',
    style: {
      backgroundColor: '#001529',
    },
  });
};

export const errorToast = (message) => {
  toast.error(message, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    theme: 'dark',
    style: {
      backgroundColor: '#001529',
    },
  });
};

export const messageToast = ({ notification, onClick }) => {
  playNotifySound();
  toast(
    <div className="notification-card" onClick={onClick}>
      <div className="notification-avatar">
        <UserAvatar size={40} user={notification?.user} />
      </div>
      <div className="notification-content">
        <div className="notification-header">
          <h3 className="notification-username truncate">{notification?.user?.name}</h3>
          <p className="notification-time">{formatChatTime(notification?.message?.createdAt)}</p>
        </div>
        <div className="notification-body">
          <p className="notification-text truncate">{notification?.message?.message}</p>
        </div>
      </div>
    </div>,
    {
      position: 'bottom-right',
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: 'dark',
      className: 'message-toast',
    }
  );
};
